export const BACKEND_URL = 'https://scraper-ceny-backend-production.up.railway.app'

export const API_KEY = process.env.REACT_APP_API_KEY || ''

export function apiHeaders() {
  return { 'x-api-key': API_KEY, 'Content-Type': 'application/json' }
}
